<template>
    <checkbox-input v-model="checked" @input="apply">{{ brandName }}</checkbox-input>
</template>

<script>
    export default {
        props: {
            brandName: {
                type: String,
                required: true,
            },
            active: {
                type: Boolean,
                required: true,
            },
            url: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                checked: this.active,
            };
        },

        methods: {
            apply() {
                window.location.href = this.url;
            },
        },
    };
</script>
